export default (h, params, key) => {
    const text = params.row[key];
    return h('Poptip', {
        class: 'ellipsis',
        props: {
            placement: 'top',
            transfer: true,
            trigger: 'hover',
            content: text,
        }
    }, [
        h('div', text)
    ]);
};



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/tableEllipsis.js